module.exports = __webpack_public_path__ + "static/media/18GalleryPuppets.700f9cc5.jpeg";